import InsightItem from 'components/InsightItem';
import SegmentedBar from 'components/SegmentedBar';
import { useAtomValue } from 'jotai';
import React from 'react';
import { Card } from 'reactstrap';

import { assetDataAtom } from './state';

const AssetInsights: React.FC = () => {
  const assetData = useAtomValue(assetDataAtom);
  const insights = assetData?.insights;

  if (!insights) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-fluid border border-light rounded p-0 mb-1">
      <Card
        className="mb-0 px-3 py-1"
        style={{ backgroundColor: 'rgba(34, 42, 66, 0.02)' }}
      >
        <div className="d-flex flex-wrap align-items-center">
          {/* Severity */}
          <div
            className="mr-2 pr-2 flex-grow-1 border-right"
            style={{ borderColor: '#dee2e6' }}
          >
            <h6 className="mb-0">Severity:</h6>
            <SegmentedBar
              height="5px"
              width="100%"
              segments={[
                {
                  color: 'urgent',
                  value: insights.urgent,
                  label: 'Urgent',
                },
                {
                  color: 'critical',
                  value: insights.critical,
                  label: 'Critical',
                },
                {
                  color: 'serious',
                  value: insights.serious,
                  label: 'Serious',
                },
                {
                  color: 'medium',
                  value: insights.medium,
                  label: 'Medium',
                },
                {
                  color: 'minimal',
                  value: insights.minimal,
                  label: 'Minimal',
                },
              ]}
              labelDisplay="value"
              tooltip={`Urgent: ${insights.urgent}, Critical: ${insights.critical}, Serious: ${insights.serious}, Medium: ${insights.medium}, Minimal: ${insights.minimal}`}
            />
          </div>
          <div
            className="mr-2 pr-2 flex-grow-1 border-right"
            style={{ borderColor: '#dee2e6' }}
          >
            <h6 className="mb-0">Compliance Status:</h6>
            <SegmentedBar
              height="5px"
              width="100%"
              segments={[
                {
                  color: 'fail',
                  value: insights.total_failed_postures,
                  label: 'Failed',
                },
                {
                  color: 'pass',
                  value: insights.total_passed_postures,
                  label: 'Passed',
                },
              ]}
              labelDisplay="value"
              tooltip={`Failed: ${insights.total_failed_postures}, Passed: ${insights.total_passed_postures}`}
            />
          </div>

          {/* Count Summaries */}
          {/* Unique Policy Count */}
          <InsightItem
            label="Policies *"
            value={insights.unique_policy_count}
            tooltip="Policies with findings"
          />
          <InsightItem label="Assets" value={insights.total} />
          <InsightItem
            label="Findings"
            value={
              insights.total_failed_postures + insights.total_passed_postures
            }
          />
          <InsightItem
            label="Operating Systems"
            value={insights.unique_os_count}
            isLast={true}
          />
        </div>
      </Card>
    </div>
  );
};

export default AssetInsights;
